// extracted by mini-css-extract-plugin
export default {"noMargin":"footer_noMargin__Rtc9g"};